// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rule-line[data-v-368f10cf] {\n  line-height: 24px;\n}\n.spec-row[data-v-368f10cf] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n.spec-name[data-v-368f10cf] {\n  width: 180px;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 180px;\n          flex: 0 0 180px;\n}", ""]);
// Exports
module.exports = exports;
